import {
  PlacementWarningDialog,
  type PlacementWarningDialogProps,
} from '@/components/app/placement/placement-warning-dialog'

export function TextToImageWarningDialog(props: PlacementWarningDialogProps) {
  return (
    <PlacementWarningDialog
      {...props}
      tone="destructive"
      title="Replace text with image?"
      message="Your text will be erased and replaced with this image."
      continueLabel="Replace"
    />
  )
}
